const ViewBonusHistoryConstant = {
    400051: true,
    400041: true,
    4006412: false,
    4006410: false,
    400681: false,
    400351:true
}
export default ViewBonusHistoryConstant;